// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"style_PageTitle__1rRrJ"};